import { useMemo } from 'react';

const OKX = ({ ...props }) => {
  const id1 = useMemo(() => {
    return `okx_${Math.random().toString(36).substring(7)}_1`;
  }, []);
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <g clipPath={`url(#${id1})`}>
        <path d='M24 0H0V24H24V0Z' fill='black' />
        <path
          d='M14.0448 9.74402H10.1664C10.0032 9.74402 9.86877 9.87842 9.86877 10.0416V13.92C9.86877 14.0832 10.0032 14.2176 10.1664 14.2176H14.0448C14.208 14.2176 14.3424 14.0832 14.3424 13.92V10.0416C14.3424 9.87842 14.208 9.74402 14.0448 9.74402Z'
          fill='white'
        />
        <path
          d='M9.56162 5.27039H5.68322C5.52002 5.27039 5.38562 5.40479 5.38562 5.56799V9.44639C5.38562 9.60959 5.52002 9.74399 5.68322 9.74399H9.56162C9.72482 9.74399 9.85922 9.60959 9.85922 9.44639V5.56799C9.85922 5.40479 9.72482 5.27039 9.56162 5.27039Z'
          fill='white'
        />
        <path
          d='M18.5281 5.27039H14.6497C14.4865 5.27039 14.3521 5.40479 14.3521 5.56799V9.44639C14.3521 9.60959 14.4865 9.74399 14.6497 9.74399H18.5281C18.6913 9.74399 18.8257 9.60959 18.8257 9.44639V5.56799C18.8257 5.40479 18.6913 5.27039 18.5281 5.27039Z'
          fill='white'
        />
        <path
          d='M9.56162 14.2272H5.68322C5.52002 14.2272 5.38562 14.3616 5.38562 14.5248V18.4032C5.38562 18.5664 5.52002 18.7008 5.68322 18.7008H9.56162C9.72482 18.7008 9.85922 18.5664 9.85922 18.4032V14.5248C9.85922 14.3616 9.72482 14.2272 9.56162 14.2272Z'
          fill='white'
        />
        <path
          d='M18.5281 14.2272H14.6497C14.4865 14.2272 14.3521 14.3616 14.3521 14.5248V18.4032C14.3521 18.5664 14.4865 18.7008 14.6497 18.7008H18.5281C18.6913 18.7008 18.8257 18.5664 18.8257 18.4032V14.5248C18.8257 14.3616 18.6913 14.2272 18.5281 14.2272Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id={id1}>
          <rect width='24' height='24' rx='6' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default OKX;
